import Page from "webPage/Page";
import Track from "util/Track";
import $ from "jquery";
import Gallery, { DIRECTION_FORWARDS } from "webPage/Gallery";
import {handleAccordion} from "../util/LogoSection";

Page.register('page-template-homepage', () => {

    new Track($('.js-track-wrap'), {
        classes: {
            block: "slider",
        },
    });

    let gallery = new Gallery($('.js-hero-slider'), {
        itemClass: "hero__slide",
        pipClass: "hero__pip",
        navigateClass: "js-navigate",
        pipsClass: "js-pips",
        itemsClass: "js-items",
        itemActiveModifier: "active",
        pipActiveModifier: "active",
        animationDuration: 1200,
        applyMinHeight: false,
        keyboardEvents: false,
    });

    let timeout = galleryTimeout();

    function galleryTimeout() {
        return setTimeout(() => {
            gallery.navigate(DIRECTION_FORWARDS);

            setTimeout(() => {
                timeout = galleryTimeout();
            });
        },  5000);
    }

    gallery.on('navigate, goTo', () => {
        clearTimeout(timeout);
    });

    handleAccordion();
});
